import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UploadEntitiesComponent } from '@netfoundry-ui/feature/upload-entities';
import { ZitiResourceHelper } from '@netfoundry-ui/feature/ziti-resource-helper';
import { ProcessExecutionServiceV2 } from '@netfoundry-ui/shared/apiv2';
import { AuthorizationService } from '@netfoundry-ui/shared/authorization';
import { FrontdoorExtensionAvailabilityService } from '@netfoundry-ui/shared/frontdoor-selection';
import { Environment, ENVIRONMENT, Network, NetworkGroup } from '@netfoundry-ui/shared/model';
import {AgentService, AlertsHeaderActionService, AlertsTimeRangeService, ApiService, FeatureService, hasNetworkExtension, INFRASTRUCTURE_URLS, LoggerService, NETWORK_EXTENSIONS, URLS} from '@netfoundry-ui/shared/services';
import _ from 'lodash';
import { ReplaySubject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { PagedGetOption } from '@lagoshny/ngx-hateoas-client';

@Component({
    selector: 'app-list-header',
    templateUrl: './list-header.component.html',
    styleUrls: ['./list-header.component.scss'],
    standalone: false
})
export class ListHeaderComponent implements OnInit, OnDestroy {
    @Input() title = '';
    @Input() network: any = new Network({});
    @Input() organization = new NetworkGroup({});
    @Input() breadcrumb = '';
    @Input() actionTitle = '';
    @Input() tabs = '';
    @Input() url = '';
    @Input() hasAzureSubscription = false;
    @Input() shortBreadCrumbs = false;
    /** Hides the Subscriptions tab in the shared 'billing-management' tab set. Defaults to false
     * so existing consumers (e.g. nfconsole) are unaffected; cloud-ziti opts in explicitly. */
    @Input() hideSubscriptionsTab = false;
    /** Hides the Role Templates tab in the 'users' tab set. nfconsole sets it, because only cloud-ziti offers role templates. */
    @Input() hideRoleTemplatesTab = false;

    processes = [];
    activeProcess = false;
    // REPLAY Subject is important because it stores the most current value, not just a change emitter
    currentNetworkSource = new ReplaySubject<any>(1);
    currentNetwork: any = this.currentNetworkSource.asObservable();
    isTeamsTierSub = true;

    isSelfService = false;
    isEnterprise = true;
    tenantLabel = '';
    tenantId = '';
    isV2;
    isTCPenabled;
    // Per-network opt-in via the IPSEC_TUNNELER network extension.
    isIPsecEnabled;
    // Per-network opt-in via the AI_ASSISTANT network extension.
    aiAssistantEnabled = false;
    // The same opt-in, on the network of the selected Frontdoor, for the FD Settings strip.
    fdAiAssistantEnabled = false;
    Subscriptions_VWAN = URLS.SUBSCRIPTIONS;
    Subscriptions_VIRTUALWAN = URLS.V6_VWAN;
    Subscriptions_AAD = URLS.CLIENT_SYNC_AAD;
    Subscriptions_AD = URLS.CLIENT_SYNC_AD;
    Ziti_Endpoints = URLS.ZITIENDPOINTS;
    Ziti_Services = URLS.ZITISERVICES;
    Ziti_Configs = URLS.ZITICONFIGS;
    Ziti_Config_Types = URLS.ZITICONFIGTYPES;
    Network_Group_Summary = URLS.NETWORK_GROUP_SUMMARY;
    Resource_Usage = URLS.RESOURCE_USAGE;
    Daily_Stats = URLS.DAILYSTATS;
    Daily_Endpoint_Utilization = URLS.DAILY_ENDPOINT_UTILIZATION;
    Certificate_Authorities = URLS.CERTIFICATE_AUTHORITIES;
    Ziti_Certificate_Authorities = URLS.ZITI_CERTIFICATE_AUTHORITIES;
    Ziti_AppWans = URLS.ZITIAPPS;
    Edge_Routers = URLS.ZITIROUTERS;
    Billing = URLS.BILLING;
    App_Billing = URLS.BILLING_DASHBOARD;
    Org_Billing = URLS.ORG_BILLING;
    Support_Billing = URLS.SUPPORT_BILLING;
    Users = URLS.USERS;
    UserRoles = URLS.USER_ROLES;
    Manage_Invitations = URLS.MANAGE_INVITATIONS;
    Role_Templates = URLS.ROLE_TEMPLATES;
    Tokens = URLS.TOKENS;
    Shares = URLS.FRONTDOOR;
    Namespaces = URLS.FRONTDOOR_NAMESPACES;
    IpsecTunnels = URLS.FRONTDOOR_IPSEC_TUNNELS;
    Ipsec_Tunnelers = URLS.IPSEC_TUNNELERS;
    Ipsec_Shares = URLS.FRONTDOOR_IPSEC_SHARES;
    Http_Shares = URLS.FRONTDOOR_HTTP;
    Tcp_Shares = URLS.FRONTDOOR_TCP;
    Fd_Http_Shares = URLS.FD_HTTP_SHARES;
    Fd_Domain_Names = URLS.FD_DOMAIN_NAMES;
    Fd_Oidc_Providers = URLS.FD_OIDC_PROVIDERS;
    Fd_Tcp_Shares = URLS.FD_TCP_SHARES;
    Fd_Tcp_Certificates = URLS.FD_TCP_SHARES_CERTIFICATES;
    Fd_Tcp_Tokens = URLS.FD_TCP_SHARES_TOKENS;
    Fd_Tcp_Server_Certificates = URLS.FD_TCP_SHARES_SERVER_CERTIFICATES;
    Fd_Tcp_Server_Certificate_Requests = URLS.FD_TCP_SHARES_SERVER_CERTIFICATE_REQUESTS;
    Fd_Ipsec = URLS.FD_IPSEC;
    Fd_Ipsec_Tunnels_Tab = { tab: 'tunnels' };
    Fd_Agents = URLS.FD_AGENTS;
    Fd_Processes = URLS.FD_PROCESSES;
    Fd_Alerts = URLS.FD_ALERTS;
    Fd_Settings = URLS.FD_SETTINGS;
    Fd_Operations_Http = URLS.FD_OPERATIONS_HTTP;
    Fd_Operations_Mtls = URLS.FD_OPERATIONS_MTLS;
    Fd_Settings_Ai_Assistant = URLS.FD_SETTINGS_AI_ASSISTANT;
    Organizations = URLS.ORGANIZATIONS;
    Oidc_Audiences= URLS.OIDC_AUDIENCES;
    Oidc_Identity_Audience_Maps = URLS.OIDC_IDENTITY_AUDIENCE_MAP;
    Oidc_Public_Clients= URLS.OIDC_PUBLIC_CLIENTS;
    Oidc_Public_Client_Org_Mapping= URLS.OIDC_PUBLIC_CLIENT_ORG_MAPPING;
    Settings = URLS.SETTINGS;
    Gateways = URLS.GATEWAYS;
    Clients = URLS.CLIENTS;
    Groups = URLS.GROUPS;
    Azure_Virtual_Wan_Sites = URLS.VIRTUALWANSITES;
    Appwans = URLS.APPWANS;
    Services = URLS.SERVICES;
    Customers = URLS.CUSTOMERS;
    Customer_Processes = URLS.CUSTOMER_PROCESS_EXECUTIONS;
    Notifications = URLS.NOTIFICATIONS;
    Management_Events = URLS.MANAGEMENT_EVENTS;
    Metrics = URLS.METRICS;
    CZ_Metrics = INFRASTRUCTURE_URLS.METRICS;
    Fabric_Latency = URLS.FABRIC_LATENCY;
    Controller_Latency = URLS.CONTROLLER_LATENCY;
    Fabric_Latency_Timeouts = URLS.FABRIC_LATENCY_TIMEOUTS;
    Network_Controllers = URLS.NETWORK_CONTROLLERS;
    Allocated_Ips = URLS.ALLOCATED_IPS;
    Network_Operations = INFRASTRUCTURE_URLS.OPERATIONS;
    Network_Operations_Upgrades = INFRASTRUCTURE_URLS.OPERATIONS_UPGRADES;
    Network_Operations_Backups = INFRASTRUCTURE_URLS.OPERATIONS_BACKUPS;
    Network_Operations_Support_Info = INFRASTRUCTURE_URLS.OPERATIONS_SUPPORT_INFO;
    Alerts = URLS.ALERTS;
    Mutes = URLS.MUTES;
    Latency_Policies = URLS.LATENCY_POLICIES;
    Offline_Policies = URLS.OFFLINE_POLICIES;
    Network_Settings = INFRASTRUCTURE_URLS.SETTINGS;
    Network_Settings_Ai_Assistant = INFRASTRUCTURE_URLS.SETTINGS_AI_ASSISTANT;
    Network_Settings_Firewall_Info = INFRASTRUCTURE_URLS.SETTINGS_FIREWALL_INFO;
    Traffic_Analysis = URLS.TRAFFIC_ANALYSIS;
    Stored_Secrets = URLS.STORED_SECRETS;
    Network_Events = URLS.NETWORK_EVENTS;
    Alarms = URLS.ALARMS;
    Posture_Checks = URLS.POSTURE_CHECKS;
    Payment_Profile = URLS.PAYMENT_PROFILE;
    Billing_Payment_Profile = URLS.BILLING_PAYMENT_PROFILE;
    Org_Payment_Profile = URLS.ORG_PAYMENT_PROFILE;
    Support_Payment_Profile = URLS.SUPPORT_PAYMENT_PROFILE;
    Account_Details = URLS.ACCOUNT_DETAILS;
    Billing_Subscriptions = URLS.BILLING_SUBSCRIPTIONS;
    Billing_Subscription_Overages = URLS.BILLING_SUBSCRIPTION_OVERAGES;
    Billing_Subscription_Invoices = URLS.BILLING_SUBSCRIPTION_INVOICES;
    Billing_Subscription_Usage = URLS.BILLING_SUBSCRIPTION_USAGE;
    Billing_Subscription_Usage_Report = URLS.BILLING_SUBSCRIPTION_USAGE_REPORT;
    Billing_Account_Details = URLS.BILLING_ACCOUNT_DETAILS;
    App_Billing_Subscription_Overages = URLS.APP_BILLING_SUBSCRIPTION_OVERAGES;
    App_Billing_Subscription_Invoices = URLS.APP_BILLING_SUBSCRIPTION_INVOICES;
    App_Billing_Subscription_Usage = URLS.APP_BILLING_SUBSCRIPTION_USAGE;
    App_Billing_Subscription_Usage_Report = URLS.APP_BILLING_SUBSCRIPTION_USAGE_REPORT;
    Org_Account_Details = URLS.ORG_ACCOUNT_DETAILS;
    Org_Billing_Subscription_Overages = URLS.ORG_BILLING_SUBSCRIPTION_OVERAGES;
    Org_Billing_Subscription_Usage = URLS.ORG_BILLING_SUBSCRIPTION_USAGE;
    Org_Billing_Subscription_Usage_Report = URLS.ORG_BILLING_SUBSCRIPTION_USAGE_REPORT;
    Support_Account_Details = URLS.SUPPORT_ACCOUNT_DETAILS;
    Support_Billing_Subscription_Overages = URLS.SUPPORT_BILLING_SUBSCRIPTION_OVERAGES;
    Support_Billing_Subscription_Usage = URLS.SUPPORT_BILLING_SUBSCRIPTION_USAGE;
    Support_Billing_Subscription_Usage_Report = URLS.SUPPORT_BILLING_SUBSCRIPTION_USAGE_REPORT;
    Auth_Policies = URLS.AUTH_POLICIES;
    JWT_Signers = URLS.JWT_SIGNERS;
    Oidc_Issuers= URLS.OIDC_ISSUERS;
    dialogRef;
    hasCreatePermission = false;
    private subscription: Subscription = new Subscription();
    User: string;

    constructor(
        public authorizationService: AuthorizationService,
        private apiService: ApiService,
        public dialogForm: MatDialog,
        public agentService: AgentService,
        public featureService: FeatureService,
        public processExecutionService: ProcessExecutionServiceV2,
        private zitiResourceHelper: ZitiResourceHelper,
        private logger: LoggerService,
        public alertsTimeRange: AlertsTimeRangeService,
        public alertsHeaderAction: AlertsHeaderActionService,
        @Inject(ENVIRONMENT) private environment: Environment,
        private frontdoorExtensions: FrontdoorExtensionAvailabilityService
    ) {}

    _resourceType = '';

    get resourceType(): string {
        return this._resourceType;
    }

    @Input() set resourceType(value: string) {
        this._resourceType = value;
        switch (this._resourceType) {
            case 'ziti-app-wan':
                this.hasCreatePermission = this.authorizationService.canCreateAppWans();
                break;
            case 'ziti-service':
                this.hasCreatePermission = this.authorizationService.canCreateServices();
                break;
            case 'ziti-endpoint':
                this.hasCreatePermission = this.authorizationService.canCreateEndpoints();
                break;
            case 'edge-router':
                this.hasCreatePermission = this.authorizationService.canCreateEdgeRouters();
                break;
            case 'edge-router-policy':
                this.hasCreatePermission = this.authorizationService.canCreateEdgeRouterPolicies();
                break;
            case 'posture-check':
                this.hasCreatePermission = this.authorizationService.canCreatePostureChecks();
                break;
        }
    }

    get uploadText(): string {
        let uploadText = '';
        switch (this._resourceType) {
            case 'ziti-app-wan':
                uploadText = `Upload ${this.featureService?.disableNewNavigation ? 'AppWANs' : 'Service Policies'}`;
                break;
            case 'ziti-service':
                uploadText = 'Upload Services';
                break;
            case 'ziti-endpoint':
                uploadText = `Upload ${this.featureService?.disableNewNavigation ? 'Endpoints' : 'Identities'}`;
                break;
            case 'edge-router':
                uploadText = 'Upload Edge Routers';
                break;
            case 'edge-router-policy':
                uploadText = 'Upload Edge Router Policies';
                break;
            case 'posture-check':
                uploadText = 'Upload Posture Checks';
                break;
        }
        return uploadText;
    }

    ngOnInit() {
        this.subscription.add(
            this.apiService.currentTenant.subscribe((tenant) => {
                this.tenantId = tenant.id;
                this.tenantLabel = tenant.label;
                this.agentService.getAccountById(this.tenantId).subscribe((data: any) => {
                    if(data.version === 1) {
                        this.isV2 = false;
                    } else {
                        this.isV2 = true;
                    }
                    if(data.tcpSharesEnabled === true) {
                        this.isTCPenabled = true;
                    } else {
                        this.isTCPenabled = false;
                    }
                    this.isIPsecEnabled = data.ipsecSharesEnabled === true;
                })

            })
        );

        this.subscription.add(
            this.apiService.currentNetwork.pipe(debounceTime(1000)).subscribe((network) => {
                this.currentNetwork = network;
                this.aiAssistantEnabled = hasNetworkExtension(network, NETWORK_EXTENSIONS.AI_ASSISTANT);
            })
        );

        this.subscription.add(
            this.frontdoorExtensions.enabled$(NETWORK_EXTENSIONS.AI_ASSISTANT).subscribe((enabled) => {
                this.fdAiAssistantEnabled = enabled;
            })
        );

        this.subscription.add(
            this.apiService.currentSubscription.subscribe((subscription) => {
                this.isTeamsTierSub = this.featureService.isSelfServiceTeamsTier(subscription);
                this.isSelfService = this.featureService.isSelfServiceAccount(subscription);
                this.isEnterprise = !this.isSelfService;
            })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    isTabSelected(currentUrl: string, tabUrl: string): boolean {
        return (currentUrl ?? '').split('?')[0].split('#')[0] === tabUrl;
    }

    /**
     * Which of the FD IPsec section's two listings is on screen, from the `tab` query parameter, or '' when
     * the url is not that section. The section is one route with two listings, so {@link isTabSelected}
     * cannot tell them apart: it strips the query so the other FD pages match on their path alone.
     */
    fdIpsecTab(currentUrl: string): string {
        if (!this.isTabSelected(currentUrl, this.Fd_Ipsec)) {
            return '';
        }
        const query = (currentUrl ?? '').split('?')[1] ?? '';
        return new URLSearchParams(query.split('#')[0]).get('tab') === 'tunnels' ? 'tunnels' : 'shares';
    }

    /**
     * The one time window the Alerts page is read against, on the line with its tabs.
     *
     * Drawn here rather than on the page because it scopes two sections of it — the
     * Overview counts and the listing — and a control that belongs to neither belongs
     * above both. The state is the service's; this component only paints it.
     *
     * Alerts only. Mutes and Latency Policies share this tab strip and neither has a time
     * window, so the pill would be a control with nothing to act on.
     */
    showAlertsTimeRange(currentUrl: string): boolean {
        return this.isTabSelected(currentUrl, this.Alerts);
    }

    get edgeRoutersTabLink(): string {
        const link = this.featureService.betaListRoute(INFRASTRUCTURE_URLS.MANAGED_ROUTERS);
        return link === INFRASTRUCTURE_URLS.MANAGED_ROUTERS ? INFRASTRUCTURE_URLS.ROUTERS : link;
    }

    isEdgeRoutersTabSelected(currentUrl: string): boolean {
        const url = (currentUrl ?? '').split('?')[0].split('#')[0];
        return (
            url === INFRASTRUCTURE_URLS.MANAGED_ROUTERS ||
            url.startsWith(`${INFRASTRUCTURE_URLS.MANAGED_ROUTERS}/`) ||
            url === INFRASTRUCTURE_URLS.ROUTERS ||
            url.startsWith(`${INFRASTRUCTURE_URLS.ROUTERS}/`)
        );
    }

    openResourceUploadDialog() {
        this.dialogRef = this.dialogForm.open(UploadEntitiesComponent, {
            data: {
                resourceType: this.resourceType,
            },
            minHeight: '100%',
            minWidth: '100%',
            height: '100%',
            width: '100%',
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _initProcessCheck() {}

    getProcessExecutions() {
        this.processExecutionService
            .getProcessExecutionPage(this.getOptions())
            .then(
                (result) => {
                    this.processes = result;
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    this.activeProcess = _.some(this.processes, (process) => {});
                    _.delay(() => {
                        this.getProcessExecutions();
                    }, 10000);
                },
                (result) => {
                    this.logger.error('Unable to load processes for this network');
                }
            )
            .catch((result) => {
                this.logger.error('Unable to load processes for this network');
            });
    }

    getOptions(): PagedGetOption {
        const options = {
            params: {
                networkId: this.currentNetwork.id,
            },
            pageParams: {
                size: 50,
                page: 0,
            },
        };
        return options;
    }

    showUploadLink() {
        if (!this.isEnterprise || this.environment.v3Enabled) {
            return false;
        }

        switch (this._resourceType) {
            case 'ziti-app-wan':
                return this.authorizationService.canCreateAppWans();
            case 'ziti-service':
                return this.authorizationService.canCreateServices();
            case 'ziti-endpoint':
                return this.authorizationService.canCreateEndpoints();
            case 'edge-router':
                return this.authorizationService.canCreateEdgeRouters();
            case 'edge-router-policy':
                return this.authorizationService.canCreateEdgeRouterPolicies();
            case 'posture-check':
                return this.authorizationService.canCreatePostureChecks();
            default:
                return false;
        }
    }
}
